import React from 'react';
import { useTranslation } from 'react-i18next';
import ReservationPackages from '../ReservationPackages/ReservationPackages';
import { IReservationViewModel } from '../Reservations/Reservations';
import '../Reservations/Reservations.css';

interface Props {
  reservation: IReservationViewModel;
  onClose: () => void;
  onSaved?: () => void;
}

const ReservationPackagesModal = ({ reservation, onClose, onSaved }: Props) => {
  const { i18n } = useTranslation();

  return (
    <div className="reservation-modal reservation-packages-overlay">
      <div className="reservation-modal-content reservation-packages-modal">
        <div className="reservation-modal-top">
          <span className="reservation-kicker">{i18n.t('reservationDesk.managePackages')}</span>
          <h3>{i18n.t('reservationDesk.packageModalTitle')}</h3>
        </div>

        <ReservationPackages reservation={reservation} onSaved={onSaved} />

        <div className="modal-actions">
          <button onClick={onClose}>{i18n.t('generic.close')}</button>
        </div>
      </div>
    </div>
  );
};

export default ReservationPackagesModal;
